module.exports = __webpack_public_path__ + "img/018.8509380b.png";